import {
    REQUEST_TEST,
    RECEIVED_TEST,
    CHECKED_QUESTION,
    MARKED_QUESTION,
    TOUCHED_QUESTION,
    TEST_TIME_START,
    TEST_TIME_END,
    CLEAR_TEST,
    SELECTED_ANSWERS,
    QUESTIONS_INFO,
    CHANGE_QUESTION, 
    ERROR_TEST
  } from "./../constants"; 
  
  const initialState = {};
  
  export default (state = initialState, action) => { 
    switch (action.type) {
      case REQUEST_TEST:
        return {
          ...state,
          loading: true,
          requestedTestId: action.requestedTestId,
          error: false,
          errorInfo: null,
        };
      case RECEIVED_TEST: 
          return {
              ...state,
              loading: false, 
              test: action.test,
              testDuration: action.duration,
              testId: action.testId,
              activeQuestion:0,
              questionsInfo:[],
              totalResponse: action.data,
              passages: action.passages                 
          }
      case ERROR_TEST: 
          return {
            ...state,
            loading: false,
            error: true,
            errorInfo: action.error
          }
      case SELECTED_ANSWERS: 
          return {
            ...state,
            selectedAnswers: action.answer,           
          }
      case CHANGE_QUESTION:
          return {
            ...state,
            activeQuestion:action.qustionsNo,
            touched: true
          }
      case MARKED_QUESTION:
          return {
            ...state,
            questionsInfo:action.questions,          
          }
      case CLEAR_TEST:
          return {
              ...initialState
          }
      default:
        return state;
    }
  };
  